<template>
    <div>
        <div class="el-row mb-2">
            <h2 class="el-table__inner-title">Material</h2>
        </div>
        <div class="el-package-group-wrapper">
            <div class="el-row">
                <div class="el-table-info">
                    <div class="el-table-info__panel">
                        <ul class="mt-0">
                            <li>
                                {{ $t('table.data.label.ref')
                                }}<input
                                    class="el-table-info__input el-table-info__input--sm"
                                    :readonly="readonly"
                                    v-model="blcPackage.Reference"
                                />
                            </li>
                            <li>
                                {{ $t('table.data.label.ord')
                                }}<input
                                    class="el-table-info__input el-table-info__input--sm"
                                    :readonly="readonly"
                                    v-model="blcPackage.OrderNo"
                                />
                            </li>
                            <li>
                                <div
                                    class="input-group-inline"
                                    :class="{ readonly: readonly }"
                                >
                                    <label class="form-label-inline">{{
                                        $t('table.data.label.supplier')
                                    }}</label>
                                    <v-select
                                        :items="suppliers"
                                        :readonly="readonly"
                                        item-text="SupplierName"
                                        combobox
                                        return-object
                                        v-model="supplier"
                                        required
                                    >
                                    </v-select>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="el-table-info__actions" v-if="!readonly">
                        <v-btn
                            class="el-table-info__btn el-table-info__btn--sm btn btn--flat"
                            flat
                            @click.stop="
                                openTimeline(
                                    blcPackageId,
                                    'PACKAGE_GROUP',
                                    blcPackage.ReferenceCode
                                )
                            "
                        >
                            <i class="material-icons">info</i>
                        </v-btn>
                        <v-btn
                            class="el-table-info__btn el-table-info__btn--lg el-table-info__btn--primary btn btn--flat"
                            flat
                            @click="addItem"
                        >
                            {{ $t('button.text.addPackageItem') }}
                        </v-btn>
                        <v-btn
                            class="el-table-info__btn el-table-info__btn--sm el-table-info__btn--warning btn btn--flat"
                            flat
                            @click="$emit('delete-blc-package', blcPackage)"
                        >
                            {{ $t('button.text.delete') }}
                        </v-btn>
                    </div>
                </div>
                <el-table
                    :data="blcPackageItems"
                    class="el-table__inner-editable el-table__inner-editable--no-top-margin"
                    :class="{ readonly: readonly }"
                    style="width: 100%"
                    border
                >
                    <el-table-column :label="$t('table.column.description')">
                        <template slot-scope="{ row }">
                            <v-select
                                :items="descriptions"
                                :readonly="readonly"
                                combobox
                                v-model="row.Description"
                                required
                            >
                            </v-select>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('table.column.packageType')">
                        <template slot-scope="{ row }">
                            <v-select
                                :items="packageTypes"
                                :readonly="readonly"
                                combobox
                                v-model="row.PackageType"
                                required
                            >
                            </v-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.trackingReference')"
                    >
                        <template slot-scope="{ row }">
                            <input
                                class="el-table-input-text"
                                :readonly="readonly"
                                v-model="row.TrackingReference"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.customerReference')"
                    >
                        <template slot-scope="{ row }">
                            <input
                                class="el-table-input-text"
                                :readonly="readonly"
                                v-model="row.CustomReference"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.height')"
                        width="120"
                    >
                        <template slot-scope="{ row }">
                            <input
                                class="el-table-input-text"
                                :readonly="readonly"
                                v-model="row.Height"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.width')"
                        width="120"
                    >
                        <template slot-scope="{ row }">
                            <input
                                class="el-table-input-text"
                                :readonly="readonly"
                                v-model="row.Width"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.length')"
                        width="120"
                    >
                        <template slot-scope="{ row }">
                            <input
                                class="el-table-input-text"
                                :readonly="readonly"
                                v-model="row.Length"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.weight')"
                        width="120"
                    >
                        <template slot-scope="{ row }">
                            <input
                                class="el-table-input-text"
                                :readonly="readonly"
                                v-model="row.Weight"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!readonly"
                        class-name="el-col__action--green Padding_0"
                        width="30"
                        align="center"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <i
                                class="material-icons"
                                @click.stop="
                                    openTimeline(
                                        row.PackageItemID,
                                        'PACKAGE_ITEM',
                                        row.ReferenceCode
                                    )
                                "
                                >info</i
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!readonly"
                        class-name="el-col__action--red Padding_0"
                        width="30"
                        align="center"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <i
                                class="material-icons"
                                @click="addDuplicateItem(row)"
                                >content_copy</i
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!isInventory && !showExtraFields && !readonly"
                        class-name="el-col__action--green Padding_0"
                        width="30"
                        align="center"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <i
                                :title="$t('button.text.storeStock')"
                                class="material-icons"
                                @click="moveToStore(row)"
                                >domain</i
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!readonly"
                        class-name="el-col__action--red Padding_0"
                        width="30"
                        align="center"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <i class="material-icons" @click="deleteItem(row)"
                                >delete</i
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <viewer :images="imagesList" :options="viewerOptions">
                    <img
                        v-for="image in imagesList"
                        :src="image.Path"
                        class="img-thumbnail"
                        :key="image.Path"
                    />
                </viewer>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import 'viewerjs/dist/viewer.css'

export default {
    name: 'blc-package',

    props: [
        'dataBlcPackage',
        'notification',
        'readonly',
        'showExtraFields',
        'suppliers',
        'isInventory',
    ],

    data() {
        let blcPackageItems = _.cloneDeep(this.dataBlcPackage.PackageItems)

        return {
            blcPackageId: this.dataBlcPackage.PackageGroupID,
            blcPackage: this.dataBlcPackage,
            blcPackageItems,
            prevWatches: [],
            descriptions: [
                'Badrum',
                'Gips',
                'Isolering',
                'Kartonger',
                'Kolli över 1,1 ton',
                'Kök',
                'Övrigt',
                'Plyfa',
                'Rör',
                'Virke',
            ],
            packageTypes: [
                'Helpall',
                'Halvpall',
                'Kartong',
                'Long',
                'Långgods',
                'Ring',
                'Special',
                'Specialgods',
                'Trumma',
            ],
            supplier: {
                SupplierID: this.dataBlcPackage.SupplierID,
                SupplierName: this.dataBlcPackage.SupplierName,
            },
            dialogVisible: false,
            currentImage: '',
            imagesList: this.dataBlcPackage.Images,
            viewerOptions: {
                toolbar: true,
                movable: true,
                zoomable: true,
                scalable: false,
                rotatable: false,
                fullscreen: false,
                title: false,
            },
        }
    },

    beforeDestroy() {
        this.unwatchItems()
    },

    created() {
        this.watchItems()
    },

    watch: {
        blcPackage: {
            handler: _.debounce(function (newVal) {
                this.updateOrCreatePackage(newVal)
            }, 300),
            deep: true,
        },

        supplier(val) {
            if (_.isObject(val)) {
                this.blcPackage.SupplierID = val.SupplierID
                this.blcPackage.SupplierName = val.SupplierName
            } else {
                this.blcPackage.SupplierName = val
            }
        },
    },

    computed: {
        ...mapGetters(['isBlc', 'selectedContainer']),

        container() {
            return this.isBlc ? this.selectedContainer : this.containerBlcData
        },
    },

    mixins: [],

    methods: {
        unwatchItems() {
            this.prevWatches.map((unwatch) => unwatch())
        },

        watchItems() {
            this.unwatchItems()
            this.prevWatches = this.blcPackageItems.map((item) => {
                return this.$watch(
                    () => {
                        return item
                    },
                    _.debounce((newVal) => {
                        this.updateOrCreatePackageItem(newVal)
                    }, 300),
                    {
                        deep: true,
                    }
                )
            })
        },

        addItem() {
            this.blcPackageItems.push({
                Height: 0,
                Width: 0,
                Length: 0,
                Weight: 0,
                Description: '',
                TrackingReference: '',
                CustomReference: '',
                PackageItemID: '',
                PackageType: '',
            })
            this.watchItems()
        },

        setImage(index) {
            this.dialogVisible = true
            if (this.imagesList && this.imagesList[index]) {
                this.currentImage = this.imagesList[index].Path
            }
        },

        addDuplicateItem(item) {
            let duplicatedItem = { ...item, PackageItemID: '' }

            this.blcPackageItems.push(duplicatedItem)
            this.createItem(duplicatedItem)
        },

        async updateOrCreatePackage(blcPackage) {
            if (this.blcPackageId) {
                this.updatePackage(blcPackage)
            } else {
                this.createPackage(blcPackage)
            }
        },

        async updatePackage(blcPackage) {
            const { data } = await this.$http.put(
                `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup/${this.blcPackageId}`,
                blcPackage
            )
            this.$emit('package-update', blcPackage)

            return data
        },

        async createPackage(blcPackage) {
            let { data } = await this.$http.post(
                `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup`,
                blcPackage
            )
            this.$emit('package-create', blcPackage)

            this.blcPackageId = data
        },

        async updateOrCreatePackageItem(item) {
            if (!this.blcPackageId) {
                await this.createPackage(this.blcPackage)
            }

            if (item.PackageItemID) {
                await this.updateItem(item)
            } else {
                await this.createItem(item)
            }
        },

        async updateItem(item) {
            const { data } = await this.$http.put(
                `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup/${this.blcPackageId}/PackageItem/${item.PackageItemID}`,
                item
            )
            this.$emit('item-update', item)

            return data
        },

        async createItem(item) {
            let { data } = await this.$http.post(
                `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup/${this.blcPackageId}/PackageItem`,
                item
            )
            item.PackageItemID = data
            this.$emit('item-create', item)
        },

        async deleteItem(item) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'item',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                let index = this.blcPackageItems.indexOf(item)

                this.blcPackageItems.splice(index, 1)

                if (!this.blcPackageItems.length)
                    this.$emit('remove-blc-package', this.blcPackage)

                if (item.PackageItemID) {
                    await this.$http.delete(
                        `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup/${this.blcPackageId}/PackageItem/${item.PackageItemID}`
                    )
                    this.$emit('item-delete', item)
                }
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        async moveToStore(item) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.moveToStock'),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                let index = this.blcPackageItems.indexOf(item)

                this.blcPackageItems.splice(index, 1)

                if (!this.blcPackageItems.length)
                    this.$emit('remove-blc-package', this.blcPackage)

                if (item.PackageItemID) {
                    await this.$http.put(
                        `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup/${this.blcPackageId}/PackageItem/${item.PackageItemID}/Status/HIDDEN_INVENTORY_TO_STOCK`
                    )
                    this.$emit('item-move-to-store', item)
                }

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'message.success.moveToStock'
                    ),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        openTimeline(id, type, code) {
            Events.$emit('show-timeline', id, type, code)
        },
    },
}
</script>

<style>
.Padding_0 .cell {
    padding-left: 0px !important;
}
.img-thumbnail {
    width: 80px;
    height: 80px;
    margin: 10px;
    cursor: pointer;
}
</style>
